import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  :root {
    font-synthesis: none;
    text-rendering: optimizeLegibility;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    padding: 0;
    background-color: ${({ theme }) => theme.backgroundPrimary};
    color: ${({ theme }) => theme.textPrimary};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-weight: 600;
    font-optical-sizing: auto;
    font-style: normal;
    line-height: 1.12;
    letter-spacing: -0.025em;
    color: inherit;
    margin: 0;
    text-wrap: balance;
  }

  p {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-weight: 400;
    line-height: 1.65;
    color: inherit;
    margin: 0 0 1em;
  }

  a, span, li, input, textarea, select, button {
    font-family: inherit;
    color: inherit;
  }

  a:focus-visible, button:focus-visible, input:focus-visible, textarea:focus-visible, select:focus-visible, summary:focus-visible {
    outline: 3px solid ${({ theme }) => theme.primary};
    outline-offset: 3px;
  }

  img, svg {
    max-width: 100%;
  }

  section[id] {
    scroll-margin-top: 120px;
  }

  ::selection {
    background: rgba(51, 122, 189, 0.22);
    color: #081526;
  }

  /* Fade-in animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .fade-in {
    animation: fadeIn 1s ease-in;
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      scroll-behavior: auto !important;
      transition-duration: 0.01ms !important;
    }
  }
`

export default GlobalStyle
